<template>
	<div id="planindex">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="岗位计划申报管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
				<el-form status-icon :model="planform" ref="planform" :rules="planrules" 
				label-width="100px" class="el-form-module" :hide-required-asterisk="isView" >
					<el-form-item label="计划名称：" prop="planName">
						<el-input v-model="planform.planName" v-if="isAdd||isEdit" ></el-input>
						<span v-if="isView">
							{{planform.planName}}
						</span>
					</el-form-item>
					<el-form-item label="计划描述：" prop="planDesc">
						<el-input v-model="planform.planDesc" type="textarea" :row="3" v-if="isAdd||isEdit" ></el-input>
						<span v-if="isView">
							{{planform.planDesc}}
						</span>
					</el-form-item>
                    <el-form-item label="开始时间：" prop="planStartdate" >
						<el-date-picker v-model="planform.planStartdate" v-if="isAdd||isEdit" value-format="yyyy-MM-dd HH:mm:ss" type="date" style="width: 100%;"></el-date-picker>
                        <span v-if="isView">
                            {{planform.planStartdate | moment("YYYY-MM-DD")}}
                        </span>
					</el-form-item>
					<el-form-item label="结束时间：" prop="planEnddate">
						<el-date-picker v-model="planform.planEnddate" v-if="isAdd||isEdit" value-format="yyyy-MM-dd HH:mm:ss" type="date" style="width: 100%;"></el-date-picker>
                        <span v-if="isView">
                           {{planform.planEnddate | moment("YYYY-MM-DD")}}
                        </span>
					</el-form-item>
                    <el-form-item label="总指标数：" prop="targetTotalnum">
                    	<el-input-number v-model="planform.targetTotalnum" controls-position="right" :min="1" v-if="isAdd||isEdit" ></el-input-number>
						<span v-if="isView" >
							{{planform.targetTotalnum}}
						</span>
					</el-form-item>
					<el-form-item label="状态：" >
						<el-select v-model="planform.status" placeholder="请选择状态" v-if="isAdd||isEdit" >
							<el-option v-for="item in statusData" :label="item.statusName" :value="item.statusValue"></el-option>
						</el-select>
                        <span v-if="isView">
                           {{planform.statusName}}
                        </span>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitForm('planform')" v-if="isAdd||isEdit" >提 交</el-button>
				<el-button  @click="resetForm('planform')" v-if="isAdd||isEdit" >重 置</el-button>
				<el-button type="info" @click="returnForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'plan_index_Detail',
		data(){
			var validateStartdate = (rule, value, callback) => {
				if (value=='') {
					callback(new Error('请输入计划开始时间'));
				}else {
					if(this.planform.planEnddate!=""){
						this.$refs.planform.validateField('planEnddate');
					}
					callback();
				}
			};
			var validateEnddate = (rule, value, callback) => {
				if (value=='') {
					callback(new Error('请输入计划结束时间'));
				}else {
					if(this.planform.planStartdate==""){
						callback(new Error('请先输入开始时间'));
					}else{
						var startD= new Date(Date.parse(this.planform.planStartdate));
						var endD=new Date(Date.parse(value));
						if(endD<startD){
							callback(new Error('结束时间不能小于开始时间'));
						}else{
							callback();
						}
					}
				}
			};
			return{
				planform:{
					planId:"",
					planName:"",
					planStartdate:"",
					planEnddate:"",
					targetTotalnum:"",
                    planDesc:"",
					status:0,
                    status_str:""
				},
				planrules:{
					planName:[ { required: true, message: '请输入计划名称' , trigger: 'blur'}],
					planStartdate:[ { required: true, validator: validateStartdate , trigger: 'blur'}],
					planEnddate:[ { required: true, validator: validateEnddate , trigger: 'blur'}],
                    targetTotalnum:[ { required: true, message: '请输入总指标数' , trigger: 'blur' }]
				},
				title:"",
				isEdit:true,
				isAdd:false,
				isView:false,
				statusData:[]
			}
		},
		methods:{
			submitForm:function(formName){
                this.$refs[formName].validate((valid) =>{
					if (valid) {
						var loading = this.$loading({
							lock: true,
							text: '提交中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						var Vuethis=this;
						var apiUrl=(this.isAdd==true)?this.$api.plan.planAdd:this.$api.plan.planmodify;
						this.$hrraxios.post(apiUrl,this.planform)
						.then(function(response){
							loading.close();
							var data=response.data;
							if(data.success==true)
							{
								Vuethis.$alert("提交成功！",{callback:action=>{
									Vuethis.$router.push({path:'/plan/index/'});
								}});
							}else{
								Vuethis.$message({message:data.prompt,type:"error"});
							}
						}).catch(function(error){
							loading.close();
							console.log(error);
						})
					} else {
						return false;
					}
				});
			},
			resetForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnForm:function(){
				this.$router.go(-1);
			},
			initData:function(){
				this.isView=false;
				this.isEdit=false;
				this.isAdd=false;
				var Hrrtype=this.$route.params.type; //类型
				var row=this.$route.meta.row;
				var info="岗位计划";
				if(Hrrtype!="add"){
					this.planform=row;
					this.$route.meta.row=null;
				}
				if(Hrrtype=="view"){
					this.title="查看"+info;
					this.isView=true;
				}
				if(Hrrtype=="edit"){
					this.title="编辑"+info;
					this.isEdit=true;

				}
				if(Hrrtype=="add"){
					this.title="新增"+info;
					this.isAdd=true;
				}
			},
			initParamsData(){
				if(this.$route.params.type!="view")
					this.$common.getStatus({forTable:"hrr_plan"},"statusData",this);
			}
		},
		created:function(){
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style>
.el-form-module{width:500px;}
.line{text-align: center;}
</style>
